module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-15.e8d4797e.JPG";